<template>
  <div>
    <el-dialog id="login-dialog"
      :visible.sync="dialogVisible"
      width="424px"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :lock-scroll="false"
      :append-to-body="true"
    >
      <el-tabs ref="loginTypeTab" v-model="tabName" style="width:310px; margin: 0 auto;">        
        <el-tab-pane label="账号密码登录" name="account">
          <el-form
            :rules="passwordLoginRules"
            ref="passwordForm"
            :model="passwordForm"
          >
            <el-form-item prop="username">
              <el-input placeholder="请输入证件号码" class="input-item" v-model="passwordForm.username"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input placeholder="请输入密码" type="password" v-model="passwordForm.password"></el-input>
            </el-form-item>
            <el-form-item prop="pCaptcha">
              <div class="input-item">
                <el-input
                  placeholder="验证码"
                  v-model="passwordForm.pCaptcha"
                  style="width:70%;"
                  class="input-code"
                  @mouseenter="genarateCode"
                ></el-input>
                <canvas
                  id="pCaptcha"
                  ref="pCaptcha"
                  width="100"
                  height="47"
                  @click="genarateCode"
                  style="border: 1px solid #ccc;border-radius: 5px;border-top-left-radius:0;border-bottom-left-radius:0"
                ></canvas>
              </div>
            </el-form-item>
            <div class="input-item" style="height:30px">
              <el-col :span="24">
                <span @click="forgetPassword()" style="float:right;cursor:pointer;">忘记密码？</span>
              </el-col>
            </div>
            <span class="dialog-footer">
          <el-button type="primary" @click="onSubmit('passwordForm')">登 录</el-button>
        </span>
          </el-form>
        </el-tab-pane>
      </el-tabs>      
    </el-dialog>
  </div>
</template>

<script>
// 引用示例的js文件
import { getToken } from "@/api/common/index";
import { drawCaptcha } from "@/helper/utils";
import { isPassWord } from "@/helper/validate";
import CryptoJS from "crypto-js";
export default {
  name: "Login",
  inject: ["reload"],
  data() {
    return {
      tabName: "account",
      loginType: 0,
      shownum: [],
      verifyCodeForm:{
        mobile: "",
        vCaptcha: "",
        vCode: ""
      },
      passwordForm: {
        // 测试账号、密码
        username: "",
        password: "",
        pCaptcha: "",
        //isopenidlogin: "", // 快捷登录（暂不用）
      },
      // 表单验证，需要在 el-form-item 元素中增加 prop 属性
      passwordLoginRules: {
        username: [
          {
            type: "String",
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                //this.$message({message:"账号不可为空",type:"error"});
                callback(new Error("证件号码不可为空"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
          //{required: true, message: '手机号码不可为空', trigger: 'blur'}
        ],
        password: [
          {
            type: "String",
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("密码不可为空"));
              } else if (!isPassWord(value)) {
                // 适当时开启
                // callback(
                //   new Error("密码不能少于6位，且包含大写字母、小写字母、数字")
                // );
                callback();
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        pCaptcha: [
          {
            type: "String",
            required: true,
            validator: (rule, value, callback) => {
              let num = this.shownum.join("").toLowerCase();
              if (!value) {
                callback(new Error("验证码不可为空"));
              } else if (value.toLowerCase() != num) {
                callback(new Error("验证码输入不正确"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      //申请和个人中心的跳转
      isapply:false,
      // 对话框显示和隐藏
      dialogVisible: true,
      loginMessageCoolDown: 0
    };
  },
  mounted() {
    var vm = this;
    setTimeout(function () {
       drawCaptcha(vm.shownum, vm.$refs.pCaptcha);
    }, 300);
  },
  methods: {
    // 提交登录
    onSubmit(formName) {      
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // Encrypt
          var username = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.passwordForm.username), CryptoJS.enc.Utf8.parse("1234567890ABCDEF"),{mode:CryptoJS.mode.ECB,padding:CryptoJS.pad.Pkcs7}).ciphertext.toString().toUpperCase();
          var password = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.passwordForm.password), CryptoJS.enc.Utf8.parse("1234567890ABCDEF"),{mode:CryptoJS.mode.ECB,padding:CryptoJS.pad.Pkcs7}).ciphertext.toString().toUpperCase();
          getToken({
            username: username,
            password: password,
            loginType: this.loginType
          })
            .then(() => {
              // 登陆成功后，执行页面跳转
              var that = this;
              if(!this.isapply){
                that.$message({
                  message: "登录成功,正在跳转到个人中心",
                  type: "success",
                });
                that.$emit("resetUserInfo");
                that.dialogVisible = false;
                that.$router.push({ path: "/User" });
                that.reload();
              }else{
                that.$message({
                  message: "登录成功,正在跳转到申请页面",
                  type: "success",
                });
                that.$emit("resetUserInfo");
                that.dialogVisible = false;
                that.$router.push({ path: "/Apply" });
                that.reload();
              }
            })
            .catch((error) => {
              this.$message({
                message: "登录失败，" + error,
                type: "error",
              });
              this.$nextTick(() => {
                drawCaptcha(this.shownum, this.$refs.pCaptcha);
              });
            });
        } else {
          return false;
        }
      });
    },
    // 点击关闭模态窗口
    handleClose: function (done) {
      done();
      this.$refs["passwordForm"].clearValidate();
    },
    // 生成验证码
    genarateCode() {
      drawCaptcha(this.shownum, this.$refs.pCaptcha);
    },
    
    forgetPassword:function(){
      this.dialogVisible = false;
      this.$router.push({ path: "/ForgetPassword" });
    }
  },
};
</script>

<style lang="scss">
#login-dialog .input-item {
  display: flex;
  flex-shrink: 0;
  margin: 10px 0 0 0;
  width: 100%;
  height: 50px;
  position: relative;
  box-sizing: border-box;
}

#login-dialog .input-item /deep/ .el-input /deep/ .el-input__inner {
  height: 50px;
}

#login-dialog .input-item .input-code /deep/ .el-input__inner{
  border-top-right-radius:0;
  border-bottom-right-radius:0
}


#login-dialog .dialog-footer .el-button {
  width: 100%;
  height: 50px;
  background: #2c79cb;
  font-size: 16px;
}

#login-dialog .vCode .el-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

#login-dialog .vCode .el-input__inner {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

#login-dialog .captcha .el-input__inner {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

#login-dialog .el-tabs .el-tabs__header,
#login-dialog .el-tabs .el-tabs__item {
  height: 53px;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #666666;
}

#login-dialog .el-tabs .el-tabs__item.is-active {
  color: #333333;
}
</style>
